import React, { useState } from "react";
import NavbarCustom from "../../../Components/NavbarCustom";
import BackBtn from "../../../Components/BackBtn/BackBtn";
import "./resetPassword.css";
import { useNavigate, useLocation } from "react-router-dom";
import { useForgetPassword } from "../../../APIContext/ForgetPasswordContext";
import Swal from "sweetalert2";


export default function ResetPassword() {
  const { loading, email, functionResetPassWord } = useForgetPassword();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [isDisabled, setIsDisabled] = useState(false);
  const navigate = useNavigate();

  const handleReset = async() => {
    if (!password || !confirm) {
      Swal.fire({
            icon: "error",
            title: "Error",
            text: "Enter you password",
            confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
          });
      return;
    }

    if (password !== confirm) {
      Swal.fire({
            icon: "error",
            title: "Error",
            text: "Passwords not matched !",
            confirmButtonColor: "#B79527", // orange / gold
      cancelButtonColor: "#1C1C1C",
          });
      return;
    }

    const data ={
      new_password: password,
    };

    setIsDisabled(true);

    try{

      await functionResetPassWord(data);

    }catch (err){

    }

   
  };

  return (
    <>
      <NavbarCustom />

      <div className="reset-container">
        <div className="reset-header">
          

          <div className="reset-header-content">
            <h1 className="reset-heading black-text-clip">Reset Password</h1>
            <p className="black-text-clip">Enter your new password for {email || "your account"}</p>
          </div>
        </div>

        <div className="reset-input-section">
          <label className="black-text-clip">New Password</label>
          <input
            type="password"
            placeholder="Enter new password"
            className="reset-input"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />

          <label className="black-text-clip">Confirm Password</label>
          <input
            type="password"
            placeholder="Re-enter password"
            className="reset-input"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
          />
        </div>

        <div className="reset-btn-container">
          <button
            className="reset-btn"
            disabled={isDisabled}
            onClick={handleReset}
            style={
              isDisabled
                ? { background: "rgb(0 0 0 / 75%)", cursor: "not-allowed" }
                : {}
            }
          >
            {isDisabled ? "Updating..." : "Reset Password"}
          </button>
        </div>
      </div>
    </>
  );
}
